/**
 * Single source of truth for which feedback widget runs in which environment.
 *
 * To change where a widget appears, edit the arrays below — nothing else.
 *
 *   Featurebase:          SDK + non-feedback widgets (What's new popup) in
 *                         every env. Each env's App ID decides the
 *                         workspace: production uses the real one, the
 *                         rest use a separate test workspace.
 *   Featurebase feedback: customer-facing feedback tab — hidden everywhere
 *                         for now (product decision). Add envs back to
 *                         its array to bring it back.
 *   Marker.io:            internal QA widget for local / dev / staging /
 *                         pre-prod
 *
 * The two feedback widgets are intentionally non-overlapping so users never
 * see both at once. If you want to overlap them (e.g. enable both on staging)
 * just add the env to both arrays — the consumers don't care.
 */
import type { AppEnv } from './env'

export const FEATUREBASE_ENABLED_ENVS: readonly AppEnv[] = [
  'local',
  'dev',
  'staging',
  'pre-prod',
  'production',
]

export const FEATUREBASE_FEEDBACK_ENABLED_ENVS: readonly AppEnv[] = []

export const MARKERIO_ENABLED_ENVS: readonly AppEnv[] = [
  'local',
  'dev',
  'staging',
  'pre-prod',
]

export function isFeaturebaseEnabled(environment: AppEnv): boolean {
  return FEATUREBASE_ENABLED_ENVS.includes(environment)
}

export function isFeaturebaseFeedbackEnabled(environment: AppEnv): boolean {
  return FEATUREBASE_FEEDBACK_ENABLED_ENVS.includes(environment)
}

export function isMarkerIoEnabled(environment: AppEnv): boolean {
  return MARKERIO_ENABLED_ENVS.includes(environment)
}
